import { AircraftDetailView } from '@/features/Aircrafts/AircraftDetailView/AircraftDetailView';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const aircraftDetailSearchSchema = z.object({
    tab: z.enum(['work-orders', 'removal-installation']).optional().default('work-orders'),
    filter: z.string().optional(),
});

export const Route = createFileRoute('/aircrafts/$aircraftId/')({
    component: AircraftDetailView,
    validateSearch: aircraftDetailSearchSchema,
});
